import { render, staticRenderFns } from "./InstrumentDetails.vue?vue&type=template&id=1bcb756a&"
import script from "./InstrumentDetails.vue?vue&type=script&lang=js&"
export * from "./InstrumentDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports